"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DefaultButton = _interopRequireWildcard(require("./DefaultButton"));

var _AddToCalendar = _interopRequireWildcard(require("../AddToCalendar"));

var Button = function Button(_ref) {
  var calendarEvent = _ref.calendarEvent,
      as = _ref.as,
      props = _objectWithoutProperties(_ref, ["calendarEvent", "as"]);

  return calendarEvent ? /*#__PURE__*/_react.default.createElement(_AddToCalendar.default, Object.assign({}, calendarEvent, props)) : /*#__PURE__*/_react.default.createElement(_DefaultButton.default, Object.assign({
    as: as
  }, props));
};

Button.propTypes = _objectSpread(_objectSpread({}, _DefaultButton.defaultButtonPropTypes), {}, {
  /** Prop Types for AddToCalendar component */
  calendarEvent: _propTypes.default.shape(_AddToCalendar.addToCalendarPropTypes)
});
Button.defaultProps = _DefaultButton.defaultButtonDefaultProps;
var _default = Button;
exports.default = _default;